import * as z from 'zod'
import {buildEntrySchemaFor} from '../entry'
import {RichTextSchema} from '../richText'

export const PrimerComponentStaticFootnotesSchema = buildEntrySchemaFor('primerComponentStaticFootnotes', {
  fields: z.lazy(() =>
    z.object({
      content: RichTextSchema,
      visuallyHiddenHeading: z.string().optional(),
    }),
  ),
})

export type PrimerComponentStaticFootnotes = z.infer<typeof PrimerComponentStaticFootnotesSchema>
